import React, { useState, useEffect } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import animationData from '../lotties/defanimation.json';
import './index.css';

const Loader = ({ setLoadingComplete }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev < 100) {
          return prev + 1;
        } else {
          clearInterval(interval);
          setLoadingComplete();
          return prev;
        }
      });
    }, 60);

    return () => clearInterval(interval);
  }, [setLoadingComplete]);

  return (
    <div className="lottie-animation">
      <div className="loader-container">
        <div className="loader-text">Ты решаешь кто будет следующим.</div>
        <div className="loader-text-mini">Децентрализованный каталог телеграм приложений..</div>
        <Player autoplay src={animationData} loop={true} className="player" />
        <div className="progress-bar">
          <div className="progress-bar-fill" style={{ width: `${progress}%` }}>
            <span className="loading-text">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
